import { Button, Card, CardContent, Grid, IconButton, Typography } from '@mui/material';
import { DatePicker, PhoneField, SelectInput, TextForm } from '../../../../components';
import CancelIcon from '@mui/icons-material/Cancel';
import { Key } from 'react';
import useManifiesto from './use-manifiesto';
import { useLocation } from 'react-router-dom';
import CustomSwalAlert from '../../../../utils/CustomSwalAlert';
import { useTranslation } from 'react-i18next';

const ManifiestoForm = () => {
  const location = useLocation();
  const {
    // t,
    control,
    countryItems,
    contentFields,
    contentAppend,
    contentRemove,
    onSubmit,
    documentId,
    navigate,
    isSigning,
    setIsSigning,
    signingDocument,
    canEdit,
  } = useManifiesto();

  const { t, i18n } = useTranslation('common');

  const signinAlert = () => {
    CustomSwalAlert(t('signStamp.title') || '', t('signStamp.text') || '', 'question', true, signingDocument);
  };

  return (
    <Grid container columnSpacing={5} rowSpacing={5}>
      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('pdfs.reference', { ns: 'placeholder' })}
          name={'reference'}
          disabled={isSigning}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('airGuide.invoice', { ns: 'placeholder' })}
          name={'invoice'}
          disabled={isSigning}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextForm
          translationFile='validations'
          control={control}
          label={t('airGuide.bill', { ns: 'placeholder' })}
          name={'bill'}
          disabled={isSigning}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DatePicker
          control={control}
          label={t('pdfs.expeditionDate', { ns: 'placeholder' })}
          name={'expeditionDate'}
          disabled={isSigning}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <SelectInput
          disabled
          control={control}
          name='countryOrigin'
          label={t('pdfs.countryOrigin', { ns: 'placeholder' })}
          items={countryItems}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <SelectInput
          disabled
          control={control}
          name='countryDestiny'
          label={t('pdfs.countryDestiny', { ns: 'placeholder' })}
          items={countryItems}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Card variant={'outlined'}>
          <CardContent>
            <Grid container columnSpacing={5} rowSpacing={5}>
              <Grid item xs={12}>
                <Typography variant='subtitle1'>{t('pdfs.consignatario', { ns: 'placeholder' })}</Typography>
              </Grid>

              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('general.name')}
                  name={'by.name'}
                  disabled={isSigning}
                />
              </Grid>

              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('pdfs.direction', { ns: 'placeholder' })}
                  name={'by.direction'}
                  disabled={isSigning}
                />
              </Grid>

              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('general.email')}
                  name={'by.email'}
                  disabled={isSigning}
                />
              </Grid>
              <Grid item xs={12}>
                <PhoneField control={control} label={t('general.phone')} name={'by.phone'} disabled={isSigning} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Card variant={'outlined'}>
          <CardContent>
            <Grid container columnSpacing={5} rowSpacing={5}>
              <Grid item xs={12}>
                <Typography variant='subtitle1'>{t('pdfs.embarcador', { ns: 'placeholder' })}</Typography>
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('pdfs.name', { ns: 'placeholder' })}
                  name={'shipper.name'}
                  disabled={isSigning}
                />
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('pdfs.direction', { ns: 'placeholder' })}
                  name={'shipper.direction'}
                  disabled={isSigning}
                />
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('general.email')}
                  name={'shipper.email'}
                  disabled={isSigning}
                />
              </Grid>
              <Grid item xs={12}>
                <PhoneField control={control} label={t('general.phone')} name={'shipper.phone'} disabled={isSigning} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Card variant={'outlined'}>
          <CardContent>
            <Grid container columnSpacing={5} rowSpacing={5}>
              <Grid item xs={12}>
                <Typography variant='subtitle1'> {t('title.notifyTo')} </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('general.name')}
                  name={'notifyto.name'}
                  disabled={isSigning}
                />
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('pdfs.contact', { ns: 'placeholder' })}
                  name={'notifyto.contact'}
                  disabled={isSigning}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Card variant={'outlined'}>
          <CardContent>
            <Grid container columnSpacing={5} rowSpacing={5}>
              <Grid item xs={12}>
                <Typography variant='subtitle1'> {t('title.destinyAgent')} </Typography>
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('general.name')}
                  name={'destinyAgent.name'}
                  disabled={isSigning}
                />
              </Grid>
              <Grid item xs={12}>
                <TextForm
                  translationFile='validations'
                  control={control}
                  label={t('pdfs.contact', { ns: 'placeholder' })}
                  name={'destinyAgent.contact'}
                  disabled={isSigning}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <Grid container columnSpacing={5} rowSpacing={5}>
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Typography variant='subtitle1'>{t('pdfs.forwarder.forwarder', { ns: 'placeholder' })}</Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.name', { ns: 'placeholder' })}
              name={'forwarder.name'}
              disabled={isSigning}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.pilot', { ns: 'placeholder' })}
              name={'forwarder.pilot'}
              disabled={isSigning}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.referenceCode', { ns: 'placeholder' })}
              name={'referenceCode'}
              disabled={isSigning}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.licensePlate', { ns: 'placeholder' })}
              name={'forwarder.licensePlate'}
              disabled={isSigning}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.van', { ns: 'placeholder' })}
              name={'forwarder.van'}
              disabled={isSigning}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.numberLicense', { ns: 'placeholder' })}
              name={'forwarder.numberLicense'}
              disabled={isSigning}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.loadingPlace', { ns: 'placeholder' })}
              name={'loadingPlace'}
              disabled={isSigning}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.exit', { ns: 'placeholder' })}
              name={'exit'}
              disabled={isSigning}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.entrance', { ns: 'placeholder' })}
              name={'entrance'}
              disabled={isSigning}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextForm
              translationFile='validations'
              control={control}
              label={t('pdfs.finalDestination', { ns: 'placeholder' })}
              name={'finalDestination'}
              disabled={isSigning}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container columnSpacing={5} rowSpacing={5}>
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Typography variant='subtitle1'>{t('general.content')}</Typography>
          </Grid>

          {contentFields.map((field: { id: Key | null | undefined }, index: number) => (
            <Grid item xs={12} key={field.id}>
              <Card variant='outlined' sx={{ p: 5, position: 'relative' }}>
                <Grid container columnSpacing={5} rowSpacing={5}>
                  <Grid item xs={12} sm={4}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.cartaPorte', { ns: 'placeholder' })}
                      name={`content.${index}.cartaPorte`}
                      disabled={isSigning}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.bl', { ns: 'placeholder' })}
                      name={`content.${index}.bl`}
                      disabled={isSigning}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.content.quantity', { ns: 'placeholder' })}
                      name={`content.${index}.quantity`}
                      disabled={isSigning}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.description', { ns: 'placeholder' })}
                      name={`content.${index}.decription`}
                      disabled={isSigning}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={'RA'}
                      name={`content.${index}.ra`}
                      disabled={isSigning}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.content.grossWeight', { ns: 'placeholder' })}
                      name={`content.${index}.grossWeight`}
                      disabled={isSigning}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.content.volume', { ns: 'placeholder' })}
                      name={`content.${index}.volume`}
                      disabled={isSigning}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <TextForm
                      translationFile='validations'
                      control={control}
                      label={t('pdfs.rate', { ns: 'placeholder' })}
                      name={`content.${index}.rate`}
                      disabled={isSigning}
                    />
                  </Grid>

                  {index !== 0 && (
                    <Grid item xs={12}>
                      <IconButton
                        onClick={() => {
                          contentRemove(index);
                        }}
                        color='error'
                        disabled={isSigning}
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          fontSize: '16px',
                          paddingLeft: '32px',
                          paddingTop: '4px',
                        }}
                      >
                        <CancelIcon />
                        {t('general.deleteContent')}
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              </Card>
            </Grid>
          ))}

          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <Button
              sx={{ color: '#00ef14' }}
              type='button'
              disabled={contentFields.length >= 12 || isSigning}
              onClick={() => {
                contentAppend({
                  cartaPorte: '',
                  bl: '',
                  quantity: null,
                  rate: null,
                  decription: '',
                  grossWeight: null,
                  volume: null,
                  ra: '',
                });
              }}
            >
              <i className='fa-solid fa-circle-plus text-xl text-green-500 mr-2' />
              <p>{t('add.content')}</p>
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Button disabled={!canEdit && isSigning} variant='contained' onClick={onSubmit}>
          {documentId === null
            ? i18n.language === 'es'
              ? 'Guardar'
              : 'Save'
            : t('budgetGuide.saveDocumentButtonTittle')}
        </Button>

        {documentId !== null && (
          <Button
            disabled={isSigning}
            variant='contained'
            sx={{ backgroundColor: '#04ec2b' }}
            onClick={() => signinAlert()}
            color='success'
          >
            {t('signStamp.btn')}
          </Button>
        )}

        {documentId !== null && (
          <Button
            variant='contained'
            onClick={() => navigate(documentId, location.pathname + '&value=2')}
            color='secondary'
          >
            {t('budgetGuide.viewDocumentButtonTittle')}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default ManifiestoForm;
